import React from "react";
import { Form, Row } from "react-bootstrap";
import { IMaskInput } from "react-imask";

const maskOptions = { mask: "(000) 000-0000" };

export default function Phone({ id, label, state, onChange }) {
  const value = state[id] ? state[id] : "";

  const handleAccept = (maskedValue) => {
    onChange && onChange({ target: { value: maskedValue, id } });
  };

  return (
    <Form.Group as={Row} controlId={id} className="mb-3">
      <Form.Label column sm={6} required>
        {label}
      </Form.Label>
      <IMaskInput
        className="form-control"
        id={id}
        mask={maskOptions.mask}
        placeholder="(123) 456-7890"
        required
        type="tel"
        pattern=".{14,}"
        maxLength={14}
        value={value}
        onAccept={handleAccept}
        data-hj-allow
      />
      <Form.Control.Feedback type="invalid">
        You must provide a valid phone number
      </Form.Control.Feedback>
    </Form.Group>
  );
}
